const ADS_RECEIPT_PATH = '/credit-portal/apply/approve-and-charge/receipt';
const extractEncodedReceiptFromUrl = (url) => {
    try {
        const pathSegments = new URL(url).pathname.split('/').filter(Boolean);
        const receiptIndex = pathSegments.indexOf('receipt');
        const receiptId = pathSegments[receiptIndex + 1];
        return receiptIndex !== -1 && receiptId?.length > 20 ? receiptId : null;
    }
    catch {
        return null;
    }
};
// Using the signingUrl, extract receipt ID for ADS approve charge
export const getReceiptRoute = (signingUrl) => {
    if (signingUrl) {
        const receiptId = extractEncodedReceiptFromUrl(signingUrl);
        if (receiptId) {
            return `${ADS_RECEIPT_PATH}/${receiptId}`;
        }
    }
    return null;
};
